<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M100.293 59.4396C100.412 61.9162 101.203 77.8775 89.9513 84.218C79.3243 90.2013 51.2715 89.5642 51.2715 82.9142C51.2715 76.2641 95.8274 75.8474 100.108 84.6228C102.168 88.8439 99.5781 92.5529 96.7025 95.1605"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M44.3353 39.2275C51.3421 39.2275 57.0222 33.5474 57.0222 26.5406C57.0222 19.5338 51.3421 13.8537 44.3353 13.8537C37.3285 13.8537 31.6484 19.5338 31.6484 26.5406C31.6484 33.5474 37.3285 39.2275 44.3353 39.2275Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M44.334 14.1037V18.4319"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M44.334 34.4349V38.7631"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M32.0059 26.4334H36.334"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.3359 26.4334H56.6641"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.4183 18.2593L44.334 26.5406L48.0371 32"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M35.8685 101.483C35.8685 101.483 28.1408 114.146 28.3968 114.146H31.3141L40.3515 102.334"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.0982 101.483C85.0982 101.483 92.8258 114.146 92.5698 114.146H89.6526L80.6152 102.334"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M95.4863 97.2145C95.4863 97.2145 103.214 106.538 102.958 106.538C100.469 106.538 100.041 106.538 100.041 106.538L92.1523 98.5719"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M95.7603 96C85.0857 104.984 62.7185 103.43 43.0243 102.364C27.4262 101.519 22.7825 94.4937 26.0033 85.3075C26.7118 83.2833 27.7477 81.3901 29.0098 79.6517C31.159 76.7047 35.6182 72.1384 43.7447 64.3155C54.2764 54.1767 53.7049 38.781 67.8325 32.0297C89.8009 21.5397 97.0403 49.0686 97.0403 49.0686"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.377 58.8681C55.6925 56.9868 58.3537 42.3293 70.088 37.3819C71.8443 36.6378 74.2138 35.9472 77.2024 35.8162"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M47.7695 74.4007C52.7109 72.6623 58.9561 71.0608 66.2611 70.5369C74.3102 69.9654 81.2996 70.8763 86.753 72.0967"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
